module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('WeexThemeView', {
    key: _vm.disabled + _vm._theme + '',
    attrs: {}
  }, [(_vm.pattern === 'plain_text') ? _c('p', {
    staticClass: " weex-el weex-text",
    class: ['btn-text', _vm.isHighlight && !_vm.disabled && _vm.pattern === 'text' && !_vm._isColmo && ("dof-text-highlight-" + _vm.type)],
    style: (_vm._processExclusiveStyle(_vm.mrTextStyle, 75, 'text')),
    attrs: {
      "aria-label": _vm.text ? _vm.text + '。按钮。' : '',
      "weex-type": "text",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onTextClicked($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.loading && _vm.size == 'small' ? '' : _vm.text))]) : _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['dof-btn', _vm.isHighlight && !_vm.disabled && !_vm._isColmo && ("dof-btn-highlight-" + _vm.type + "-" + _vm.pattern)],
    style: (_vm._px2rem(_vm.mrBtnStyle, 75)),
    attrs: {
      "accessible": true,
      "aria-label": _vm.text ? _vm.text + '。按钮。' : '',
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onClicked($event)
      }
    }
  }, [(_vm.loading) ? _c('dof-spinner', {
    staticClass: "loading-image",
    attrs: {
      "type": _vm.loadingGif
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default", [_c('p', {
    staticClass: " weex-el weex-text",
    class: ['btn-text', _vm.isHighlight && !_vm.disabled && _vm.pattern === 'text' && ("dof-text-highlight-" + _vm.type)],
    style: (_vm._processExclusiveStyle(_vm.mrTextStyle, 75, 'text')),
    attrs: {
      "aria-label": _vm.text ? _vm.text + '。按钮。' : '',
      "weex-type": "text",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onTextClicked($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.loading && _vm.size == 'small' ? '' : _vm.text))])], {}), _vm._v(" "), (_vm._isColmo && !_vm.disabled && !_vm.loading) ? _c('div', {
    staticClass: "mask weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onClicked($event)
      }
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5680972d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5680972d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-button/index.vue
// module id = 613
// module chunks = 0 1